
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(186|62|984)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
